import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const Menu = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: 0;
  width: 35px;
`;

const Item = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  line-height: 1.33;
  cursor: pointer;
  margin-bottom: 5px;
  padding: 8.5px 5px;
  text-align: center;
  user-select: none;
  transition: var(--ph-background-transition);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: var(--white);

  &:hover {
    outline: 3px solid var(--white);
  }
`;

const Avatar = styled('img')`
  width: 35px;
  height: 35px;
  border-radius: 50%;
`;

const Label = styled('div')`
  font-size: var(--ph-text-xs);
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--dark-blue);
  position: relative;
  top: calc(50% - 10px);
`;

const Icon = styled(Svg)`
  height: 19px;
  width: 19px;
  fill: var(--light-grey);
`;

export default { Menu, Item, Avatar, Icon, Label };
